import { Card, Space, Typography, theme } from "antd";
import { Users, Activity } from "lucide-react";
import { ACCOUNT_TYPES } from "commons/constants";

const { Text } = Typography;

const ROLES = [
  {
    value: ACCOUNT_TYPES.COMMUNITY_LEAD,
    icon: Users,
    title: "Community Lead",
    description: "Manage communities, memberships & recurring events",
  },
  {
    value: ACCOUNT_TYPES.WORKSHOP_ORGANISER,
    icon: Activity,
    title: "Event Organizer",
    description: "Host standalone events",
  },
];

function RoleCardSelector({ value, onChange }) {
  const { token } = theme.useToken();

  return (
    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      {ROLES.map(({ value: roleValue, icon: Icon, title, description }) => {
        const selected = value === roleValue;
        return (
          <Card
            key={roleValue}
            hoverable
            onClick={() => onChange(roleValue)}
            style={{
              cursor: "pointer",
              borderColor: selected ? token.colorPrimary : token.colorBorder,
              borderWidth: selected ? 2 : 1,
              transition: "border-color 0.2s",
            }}
          >
            <Space align="center" size={12}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  background: selected ? token.colorPrimary : token.colorFillSecondary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Icon size={18} color={selected ? token.colorWhite : token.colorPrimary} />
              </div>
              <div>
                <Text strong style={{ display: "block", fontSize: 14 }}>{title}</Text>
                <Text type="secondary" style={{ fontSize: 12 }}>{description}</Text>
              </div>
            </Space>
          </Card>
        );
      })}
    </Space>
  );
}

export default RoleCardSelector;
